import styles from "../../src/common/WordModel.module.css";
import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { usePreference } from "../context/UserContext";

// Required validation function
const required = (value) => {
  if (!value) {
    return (
      <div className="invalid-feedback d-block">This field is required!</div>
    );
  }
};

const MaintenancePopup = (props) => {

  const closeModal = () => {
    updateIsMaintenanceData(false);
  };
  const form = useRef();
  const checkBtn = useRef();

  const {
    isMaintenanceOpen,
    updateIsMaintenanceOpen,
    updateIsMaintenanceData
    , isMaintenanceData
  } = usePreference();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");



  return (
    <div className={styles.modal_container}>
      {isMaintenanceOpen && (
        <div className={styles.modal}>
          <div className={styles.modal_content}>
            {/* <span className={styles.close} onClick={closeModal}>
              &times;
            </span> */}
            <div>

              <div className="container mt-3">
                <div className="col-md-12">
                  <div>
                    <h2>Maintenance</h2>
                    <p><strong>Reason:</strong> {isMaintenanceData[0].Reason}</p>
                    {/* <p><strong>Start Time:</strong> {new Date(isMaintenanceData[0].StartTime).toLocaleString()}</p> */}
                    <p><strong>Restart On:</strong> {new Date(isMaintenanceData[0].EndTime).toLocaleString()}</p>
                
                    <img src={isMaintenanceData[0].ImageUrl} alt="Maintenance" style={{ width: '100%', maxWidth: '400px' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MaintenancePopup;
